<template>
  <TextSetting v-bind="$attrs"
    :submitOverride="submitOverride"
    :columnSelectionCode="columnSelectionCode"
  >
    <template #BinSelectionInput>
      <slot name="BinSelectionInput"></slot>
    </template>  
  </TextSetting>
</template>

<script setup>
import TextSetting from "./TextSetting.vue";

let props = defineProps([
  "columnSelectionCode"
]);

function submitOverride(selectedCells, value) {
  selectedCells.forEach(cell => {
    let tag = cell.componentArgs.tag;
    let session = tag.$session;
    let applyToAllBoards = props.columnSelectionCode == "allColumns";

    tag.committed = false;
    session.queueRequest("/cmd/changeSiteName", { siteName: value, applyToAllBoards }, response => {
      tag.value = value;
      tag.committed = true;
    });
  });
}
</script>